import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CardItem from './CardItemsSavingTime';
import { cardsDataSavingTime } from 'lib/apps/catalogue/utils/cardContentGenerators';

class SavingYouTimeSection extends PureComponent {
  static propTypes = {
    instantShopExists: PropTypes.bool.isRequired,
    oReservedExists: PropTypes.string,
  };

  getClassName() {
    const { instantShopExists, oReservedExists } = this.props;
    const bothExist = instantShopExists && oReservedExists;
    const oneExists = instantShopExists || oReservedExists;
    if (bothExist) {
      return 'cards-container-saving-time'; // 6 cards, 3 on top, 3 on bottom
    } else if (oneExists) {
      return 'cards-container-saving-time--partial'; // 5 cards, 3 on top, 2 on bottom
    } else {
      return 'cards-container-hidden'; // 4 cards, 2 on top, 2 on bottom
    }
  }

  render() {
    const data = cardsDataSavingTime();
    const { instantShopExists, oReservedExists } = this.props;

    return (
        <section className="saving-time-section">
        <h2>Saving you time</h2>
        <div
          className={this.getClassName()}

        >
        {data.map((card) => (
          <CardItem
            key={card.id}
            icon={card.icon}
            header={card.header}
            content={card.content}
            buttonText={card.buttonText}
            buttonLink={card.buttonLink}
            rightArrowIcon={card.rightArrowIcon}
            instantShopExists={instantShopExists}
            oReservedExists={oReservedExists}
          />
        ))}
        </div>
      </section>
    );
  }
}

export default SavingYouTimeSection;
